import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { CerealDropdown } from '../../Forms/SharedComponents/containers'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import { Button } from '@material-ui/core'

function CamposCambioCereal (props) {
  const { handleSubmit } = props
  return (
    <Row style={{ display: 'flex', justifyContent: 'center' }}>
      <Col md={4}>
        <CerealDropdown fieldName='cerealOrigen' />
      </Col>
      <Col md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ArrowForwardIcon />
      </Col>
      <Col md={4}>
        <CerealDropdown fieldName='cerealDestino' />
      </Col>
      <Col md={2} style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
        <Button
          onClick={handleSubmit}
          variant='contained'
          color='primary'
        >
                    Crear
        </Button>
      </Col>
    </Row>
  )
}

export default CamposCambioCereal
